<template lang="pug">
    div#map

        canvas#canvas(ref="canvas")
</template>

<script>
import { Deck, MapView, WebMercatorViewport } from '@deck.gl/core';
import { GeoJsonLayer, BitmapLayer, PolygonLayer } from '@deck.gl/layers';
import getBasemaps from './basemaps';
import bbox from '@turf/bbox';
let map;

export default {
    props: {
        geojson: Object,
        height: Number,
        location: Array,
    },
    data() {
        return {};
    },

    watch: {
        geojson(v) {
            if (!v) {
                return;
            }
            map.setProps({
                layers: this.getLayers(),
            });
        },
        location(v) {
            if (!v || v.length < 2) {
                return;
            }
            const [longitude, latitude, _] = v;
            map.setProps({
                initialViewState: {
                    longitude,
                    latitude,
                    zoom: 10 + Math.random() * 3,
                    bearing: 0,
                    pitch: 0,
                },
                layers: this.getLayers(),
            });
        },
        height: {
            handler(height) {
                if (map) {
                    map.setProps({
                        height,
                    });
                } else {
                    setTimeout(() => {
                        map.setProps({
                            height,
                        });
                    }, 500);
                }
            },
            immediate: true,
        },
    },
    mounted() {
        let h = this.height || 500;
        let longitude = 105.5;
        let latitude = 36.232395363869415;
        let zoom = 3;
        map = new Deck({
            canvas: this.$refs.canvas,
            width: '100%',
            height: h,
            initialViewState: {
                longitude,
                latitude,
                zoom,
                minZoom: 3,
                maxZoom: 18,
                bearing: 0,
                pitch: 30,
            },
            controller: true,
            views: [
                new MapView({
                    id: 'map',
                    controller: true,
                    mapStyle:
                        'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json',
                }),
            ],
            layers: this.getLayers(),
            getTooltip({ object }) {
                if (!object) return;
                const { name, all, up, down } = object.properties;
                if (!name) return;
                if (!all) return name;
                return `${name} \n 数量：${all} \n 涨：${up} \n 跌：${down}`;
            },
        });
    },
    destroyed() {
        map = null;
    },
    methods: {
        getLayers() {
            return [
                ...getBasemaps(),
                this.geojson &&
                    new GeoJsonLayer({
                        id: 'geojson-layer',
                        data: this.geojson,
                        pickable: true,
                        stroked: false,
                        filled: true,
                        extruded: true,
                        wireframe: true,

                        lineWidthScale: 20,
                        lineWidthMinPixels: 2,
                        getFillColor: d => {
                            const { all, up, down } = d.properties || {};
                            if (!all || up == down) return [255, 255, 255, 230];
                            if (up > down) return [255, 100, 100, 230];
                            return [100, 255, 100, 230];
                        },
                        getElevation: d => (d.properties.all || 0) * 500,
                        getLineColor: [0, 0, 0, 255],
                        getLineWidth: 1,
                        getPointRadius: 5,
                    }),
            ];
        },
    },
};
</script>

<style lang="stylus" scoped>
#map
    overflow hidden
#canvas
    border-radius 10px
</style>
